"use client"

import { type LucideIcon } from "lucide-react"
import { Link } from "react-router"

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

type SecondaryItem = {
  title: string
  url: string
  icon: LucideIcon
  external?: boolean
}

export function NavSecondary({ items }: { items: SecondaryItem[] }) {
  if (!items.length) return null

  const isExternalUrl = (url: string, external?: boolean) => {
    return Boolean(external) || url.startsWith("http")
  }

  return (
    <SidebarMenu>
      {items.map((item) => (
        <SidebarMenuItem key={item.title}>
          <SidebarMenuButton asChild tooltip={item.title}>
            {isExternalUrl(item.url, item.external) ? (
              <a href={item.url} target="_blank" rel="noreferrer">
                <item.icon />
                <span>{item.title}</span>
              </a>
            ) : (
              <Link to={item.url}>
                <item.icon />
                <span>{item.title}</span>
              </Link>
            )}
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  )
}

